﻿window.vaneck = window.vaneck || {};

window.vaneck.membership = {
    drawRequiredMark: function(rightSide) {
        $(".Form__Element .ValidationRequired").each(function() {
            var caption = $(this).find(".Form__Element__Caption");
            if (caption.length == 0) {
                var elementLabels = $(this).find("label");
                if (elementLabels.length == 1) {
                    $(elementLabels[0]).prepend("<span class='RequiredAsterisk'>*</span>");
                }
            } else {
                if (rightSide) {
                    caption.append("<span class='RequiredAsterisk RightSide'>*</span>");
                } else {
                    caption.prepend("<span class='RequiredAsterisk'>*</span>");
                }
            }
        });
    },

    fillSubscriptionCheckboxes: function () {
        var isSameWayEnabled = $('#hdnSameWayEnabled').val() === 'True';

        var getSubscriptionsUrl = isSameWayEnabled ? '/common/SubscriptionsElementData/GetSubscriptions' : '/common/SubscriptionsElementDataAu/GetSubscriptions';

        return $.post(getSubscriptionsUrl,
                {
                    contactId: $('input.ContactId[type="hidden"]').val(),
                    siteContextType: 'Au',
                })
            .done(function(data) {
                if (data.Success) {
                    vaneck.membership.fillSubscriptionElementBody(data.Result);
                } else {
                    window.location.href = data.RedirectUrl;
                }
            });
    },

    fillSubscriptionElementBody: function(data) {
        var elementName = $('#email_subscriptions').data("form-element-name");
        $("#email_subscriptions .registration_body").html(data);
        $("#email_subscriptions .registration_body input").attr("name", elementName);
    },

    setValueByFriendlyName: function(form, name, value) {
        var element = epi.EPiServer.Forms.getElementByFriendlyName(form, name);
        if (element != null) {
            element.val(value);
        }
    },

    countrySelectChanged: function(countrySelect) {
        var val = countrySelect.val();

        var container = $('.js-state-container');
        var id = container.data('field-id');
        var name = container.data('f-element-name');
        var required = container.hasClass('ValidationRequired');

        $('.js-state').removeAttr('id');
        $('.js-state').removeAttr('name');
        $('.js-state').removeAttr('required');
        $('.js-state').removeAttr('data-f-datainput');
        $('.js-state').hide();

        switch (!val || val.toUpperCase()) {
        case 'USA':
            showStateControl($('.js-us-state'));
            break;

        case 'CAN':
            showStateControl($('.js-canada-state'));
            break;

        default:
            showStateControl($('.js-others-state'));
            break;
        }

        function showStateControl(control) {
            control.attr('id', id);
            control.attr('name', name);
            control.attr('data-f-datainput', 'data-f-datainput');
            control.show();

            if (required) {
                control.attr('required');
            }
        }
    },

    investorTypeChanged: function(invetorTypeSelect, form) {
    var certifiedProfessionalCheckbox = epi.EPiServer.Forms.getElementByFriendlyName(form, 'CertifiedFinancialProfessional');
        var rangeOfAssetsSelect = epi.EPiServer.Forms.getElementByFriendlyName(form, 'AssetsUnderManagement');
    var groupElements = invetorTypeSelect.closest('.GroupingContainer').find('.Form__Element').not(invetorTypeSelect.closest('.Form__Element'));

        var selectedInvestorType = invetorTypeSelect.find(':selected').first().val();
        if (selectedInvestorType == 'Individual Investor') {
            if (certifiedProfessionalCheckbox != null) {
                certifiedProfessionalCheckbox.hide();
                certifiedProfessionalCheckbox.prop('checked', false);
            }
            if (rangeOfAssetsSelect != null) {
                rangeOfAssetsSelect.hide();
                rangeOfAssetsSelect.prop("selectedIndex", 0);
            }
            groupElements.each(function() {
                if ($(this).is(':visible')) {
                    $(this).hide();
                }
            });
        } else {
            if (certifiedProfessionalCheckbox != null) {
                certifiedProfessionalCheckbox.show();
            }
            if (rangeOfAssetsSelect != null) {
                rangeOfAssetsSelect.show();
            }
            groupElements.each(function() {
                if ($(this).is(':hidden')) {
                    $(this).show();
                }
            });
        }
        if (selectedInvestorType == '') {
            $('.GroupHideOnEmptyInvestorType').not(invetorTypeSelect.parents('.GroupHideOnEmptyInvestorType')).hide();
        } else {
            $('.GroupHideOnEmptyInvestorType').show();
        }
    },

    spinner: {},

  showSpinner: function () {
    vaneck.membership.spinner = doSpinner(null, null);
    },

  hideSpinner: function () {
    stopSpinner(vaneck.membership.spinner, null);
    },

    initializeSpinner: function() {
        epi.EPiServer.Forms.AsyncSubmit = true;

    $$epiforms('.EPiServerForms').on('formsStartSubmitting', function () {
      vaneck.membership.showSpinner();
            });

    $$epiforms('.EPiServerForms').on('formsSubmittedError formsSubmitted', function () {
      vaneck.membership.hideSpinner();
            });
    }
};